export class ChangeTermsPurchase {
    public endDT: string;
    public finalOfferDate: string;
    public firstPartsDT: string;
    public purchaseNumber: string;
    public secondPartsDT: string;

    // второй этап
    public secondStageInfo_startDT: string;
    public secondStageInfo_endDT: string;
    public secondStageInfo_firstPartsDT: string;
    public secondStageInfo_finalOfferDate: string;
    public secondStageInfo_secondPartsDT: string;
}


// WEBPACK FOOTER //
// ./src/app/pages/change-terms-purchase/change-terms-purchase.ts